<template>
	<el-submenu v-if="item.children" :index="item.path">
		<template slot="title">
			<i class="el-icon-location"></i>
			<span slot="title">{{item.name}}</span>
		</template>
		<el-menu-item v-for="(_item,_index) in item.children" :index="_item.path" :key="_index">
			<div class="flex" style="align-items: center;justify-content: space-between;">
				<span slot="title">{{_item.name}}</span>
				<i class="el-icon-question" @click="manual(_item,$event)" style="font-size: 14px;"></i>
			</div>
		</el-menu-item>
	</el-submenu>
	<el-menu-item v-else :index="item.path">
		<i class="el-icon-location"></i>
		<span slot="title">{{item.name}}</span>
	</el-menu-item>
</template>

<script>
	export default {
		props: {
			item: {
				type: Object,
				required: true
			}

		},
		mounted() {
			//window.console.log(this.item)
		},
		computed: {

		},
		data() {
			return {

			}
		},
		methods: {
			manual(_item,$event){
				$event.stopPropagation()
				this.$emit('manual',{data:_item})
			}
		}
	}
</script>


<style scoped>

</style>
